import Animation from './animation'
import * as d3 from 'd3-selection'
import Transformer from '../transformers/pie-bar-transformer'

/*
 * This animation is used to take series that were previously in a bar
 * chart and turn them into a pie or donut
 */
class FromBarAnimation extends Animation {

  match (serie) {
    if (!this.previous.allSerieTypes[serie.id]) {
      return false
    }

    return this.previous.allSerieTypes[serie.id].type === 'bar'
  }

  animate (serie, entering, selection, merged, exiting) {
    let self = this
      , styles = this.styles
      , prev = this.previous.allSerieTypes[serie.id].serie
      , prevSerieScale = prev.node().parentNode.__bar.serieScale

    prev.selectAll('g.rect').remove() // Remove the old rect since we're replacing them
                                      // w/ arcs that look like bars

    // Adjust the strokes so they look like bars
    entering.style('opacity', 1)
            .style('stroke-width', '4px')
            .select(d => {
              d3.select(`#${d.maskUid.id}`)
                .style('stroke-width', '0px')
            })

    // Transition the strokes so they match the end slices
    merged.style('stroke-width', styles.useStrokeWidth)
          .select(d => {
            d3.select(`#${d.maskUid.id}`)
              .transition()
              .duration(merged.duration()) // We can't inherit transitions since they don't have the same parent
              .style('stroke-width', styles.maskStrokeWidth)
          })

    merged.tween('arc', function (d) {
      let transformer = new Transformer({
          d,
          styles,
          height: Math.abs(self.previous.yScale(d.slice.data._range[0]) - self.previous.yScale(d.slice.data._range[1])),
          y: self.previous.yScale(Math.max(0, d.slice.data._range[1])),
          x: self.previous.scalers.x.groupScale(d.rangeId) + prevSerieScale(serie._columnIdx),
          width: prevSerieScale.bandwidth(),
          path: d3.select(`#${d.pathUid.id}`),
          use: d3.select(this)
        })

      return t => {
        transformer.transform(t)
      }
    })
    .on('end', function () {
      d3.select(this)
        .attr('transform', d => {
          return `translate(${d.dimensions.x + d.dimensions.width / 2}, ${d.dimensions.y + d.dimensions.height / 2})`
        })
    })
  }

}

export default FromBarAnimation
